import { render } from "./Contacts.vue?vue&type=template&id=43062d80"
import script from "./Contacts.vue?vue&type=script&lang=js"
export * from "./Contacts.vue?vue&type=script&lang=js"
script.render = render

export default script